module.exports = __WEBPACK_EXTERNAL_MODULE__48398__;